/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SurveyOverviewDetail = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        companyId: {
    type: 'number',
    isRequired: true,
},
        questionId: {
    type: 'number',
    isRequired: true,
},
        title: {
    type: 'string',
    isRequired: true,
},
        subTitle: {
    type: 'string',
    isRequired: true,
},
        Actual: {
    type: 'number',
},
        Total: {
    type: 'number',
},
    },
};